import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

export class OneClickDeliveryDateProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    const translation = this.injector.get<TranslateService>(TranslateService);
    const format = translation.instant('global.formatDate');
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.items && !!order.items.length),
      map(order => order.items[0]),
      map(item => {
        return moment(item.requestedDateTime).format(format);
      }),
    );
  }
}
